import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex min-h-full flex-col justify-center pt-4 pb-8 mx-3 mt-10 sm:px-6 lg:px-8" }
const _hoisted_2 = { class: "sm:mx-auto sm:w-full sm:max-w-md" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h2", { class: "text-center text-2xl sm:text-3xl font-bold leading-9 tracking-tight text-dark-blue" }, "Your Donation Was Successful", -1)
const _hoisted_4 = { class: "text-center text-dark-blue text-sm mt-2" }
const _hoisted_5 = { class: "sm:mx-auto sm:w-full" }
const _hoisted_6 = { class: "px-4 py-8 sm:px-12" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "flex justify-center" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "/img/campaign_created_success.svg",
    alt: "Success Image"
  })
], -1)
const _hoisted_8 = { class: "mt-8 flex justify-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Sidebar = _resolveComponent("Sidebar")!
  const _component_Footer = _resolveComponent("Footer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Sidebar),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("p", _hoisted_4, "Thank you " + _toDisplayString(_ctx.firstName) + " for your generous donation!", 1)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _hoisted_7,
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("button", {
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.continueToCampaigns && _ctx.continueToCampaigns(...args))),
              class: "py-2.5 px-28 rounded-lg shadow-lg bg-light-blue text-white"
            }, "Continue")
          ])
        ])
      ])
    ]),
    _createVNode(_component_Footer)
  ], 64))
}